module.exports = __webpack_public_path__ + "static/media/icon-complete.530df842.svg";